import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Grid, Loader, Checkbox, Feed, Popup, Label, Icon } from "semantic-ui-react";
import {
	getSecretariesActive,
	getAllFolderHelp,
	manageWaitingList,
	getStatsDashboard,
	postAssignToMe,
	acceptSupportFolderHelp,
	getSecSupportedFolders,
} from "services/folderHelp";
import { getConnectedUsers } from "services/user";
import { setFocusedFolders } from "services/folder";
import ConnectedUser from "./components/ConnectedUser";
import HelpFolderListItem from "./components/HelpFolderListItem";
import { Redirect } from "react-router-dom";
import HistoricNurseHelpModal from "../../../components/Others/HistoricNurseHelpModal";

import CustomPagination from "components/CustomPagination";
import { sendDashboardToDualScreen, stopDashboardToDualScreen, closeDashboardToDualScreen } from "services/dualScreen";
import { toast } from "react-toastify";
import moment from "moment";
import { getAllScansOrdo } from "services/folderHelp";
import ScansFolderHelpModal from "./components/ScansFolderHelpModal";
import StatsFolderHelpModal from "./components/StatsFolderHelpModal";
import { removeScanOrdo } from "services/prescription";
import { dateDiff } from "utils/dateUtils";
import Repeat from "./components/Repeat";
import SupportedFoldersContent from "./components/SupportedFoldersModal";

const styles = {
	folder: {
		backgroundColor: "#fff",
		width: "100%",
		padding: 10,
		display: "flex",
		borderRadius: "0",
		marginTop: "5px",
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		alignItems: "center",
		marginLeft: 15,
		marginRight: 15,
		position: "relative",
	},
	roundHeaderContainer: {
		height: 40,
		backgroundColor: "#43b39e",
		width: "100%",
		padding: 10,
		display: "flex",
		borderRadius: "4px 4px 0 0",
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		position: "relative",
	},
};

class HelpNurses extends Component {
	constructor(props) {
		super(props);

		this.state = {
			openFolderManager: false,
			openHistoricModal: false,
			historicFolderHelp: {},
			done: false,
			preregister: false,
			page: 1,
			nbItems: 50,
			timerDashboardId: 0,
			dashboardOpened: false,
			loadingDashboard: false,
			openScans: false,
			openStats: false,
			supportedFolders: null,
		};
	}
	timerDashboardId = 0;

	componentDidMount() {
		this.props.getConnectedUsers();
		this.loadAll();
	}

	loadAll = () => {
		this.props.getSecretariesActive();
		this.props.getAllFolderHelp(this.state.page, this.state.done, this.state.preregister, this.state.nbItems, true);
	};

	goToFolderManager = (id) => {
		this.props.setFocusedFolders([id]);
		this.setState({ openFolderManager: true });
	};

	openHistoricFolderHelpModal = (folderHelp) => {
		this.setState({ openHistoricModal: true, historicFolderHelp: folderHelp });
	};

	closeHistoricFolderHelpModal = (id) => {
		this.setState({ openHistoricModal: false });
	};

	closeSupportedFoldersForSec = () => {
		this.setState({ supportedFolders: null });
	};

	dashboardToDualScreen = () => {
		if (!this.state.dashboardOpened && this.props.dualScreen.isAvailable && !this.props.dualScreen?.presentationConnection?.id) {
			toast.warn("Pour afficher le dashboard, sélectionner d'abord un double écran disponible.");
		} else {
			if (this.props.dualScreen.isAvailable && this.props.dualScreen?.presentationConnection?.id) {
				this.setState({ loadingDashboard: true });
				this.timerDashboardId = setInterval(() => {
					this.props.getStatsDashboard().then((res) => {
						this.props.sendDashboardToDualScreen(res);
						if (this.state.loadingDashboard) this.setState({ dashboardOpened: true, loadingDashboard: false });
					});
				}, 10000);
			}
		}
	};

	closeDashboard = () => {
		clearInterval(this.timerDashboardId);
		this.timerDashboardId = 0;
		this.props.closeDashboardToDualScreen();
		this.props.sendDashboardToDualScreen(null);
		this.setState({ dashboardOpened: false, loadingDashboard: false });
	};

	getSecSupport = async (id, startDate, endDate) => {
		if (this.props.getSecSupportedFolders) {
			const result = await this.props.getSecSupportedFolders(id, startDate, endDate);
			this.setState({ supportedFolders: result?.payload?.data });
		}
	};

	render() {
		const { openFolderManager, isLoading, openHistoricModal, historicFolderHelp, done, preregister } = this.state;
		const { connectedSecretaries, folderHelps, stats, pagination, dualScreen, preregisterStats } = this.props;
		if (openFolderManager) {
			return <Redirect to="/home/foldermanager" />;
		}
		const totalConnectedSecretaries = connectedSecretaries ? connectedSecretaries.length : 0;
		const totalFolderHelps = pagination.totalCount;
		const totalWaitingFolders = folderHelps ? folderHelps.filter((f) => f.status === "NEW" || f.status === "PENDING").length : 0;
		const getWaitingFolders = (waitingFolders) => {
			var waitingInfo = { min2: 0, between210: 0, more10: 0 };
			waitingFolders.map((folderHelp) => {
				let diff = dateDiff(folderHelp.created_at);
				if (diff.day > 0 || diff.hour > 0 || diff.min > 10) {
					waitingInfo = { ...waitingInfo, more10: waitingInfo.more10 + 1 };
				} else {
					if (diff.day === 0 && diff.hour === 0 && diff.min < 2) waitingInfo = { ...waitingInfo, min2: waitingInfo.min2 + 1 };
					else waitingInfo = { ...waitingInfo, between210: waitingInfo.between210 + 1 };
				}
				return true;
			});
			return waitingInfo;
		};
		const waitingInfo = getWaitingFolders(folderHelps.filter((f) => f.status === "NEW" || f.status === "PENDING"));
		const supportInfo = getWaitingFolders(folderHelps.filter((f) => f.status === "SUPPORT" || f.status === "ASSIGNED"));

		return (
			<div
				style={{
					height: "100vh",
					overflowY: "scroll",
				}}
			>
				<Grid
					className="ui container"
					style={{
						maxHeight: "100vh",
						maxWidth: "90%",
						display: "flex",
						justifyContent: "center",
						paddingTop: 43,
					}}
				>
					<Repeat
						loadAll={this.loadAll}
						dualScreen={this.props.dualScreen.isAvailable && this.props.dualScreen?.presentationConnection?.id}
						getStatsDashboard={this.props.getStatsDashboard}
						sendDashboardToDualScreen={this.props.sendDashboardToDualScreen}
					/>
					<Grid.Row></Grid.Row>
					<Grid.Row style={styles.roundHeaderContainer}>
						<Grid.Column computer={4} tablet={6} mobile={8} style={{ color: "white" }}>
							Télésecrétariat
						</Grid.Column>
						<Grid.Column
							computer={12}
							tablet={10}
							mobile={8}
							style={{
								color: "white",
								display: "flex",
								justifyContent: "flex-end",
								alignItems: "center",
								padding: 0,
								margin: 0,
							}}
						>
							<Label
								as="a"
								color="red"
								size="small"
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									this.props.getStatsDashboard();
									this.setState({ openStats: true });
								}}
							>
								<Icon name="th" />
								Statistiques
							</Label>

							<Label
								as="a"
								color="blue"
								size="small"
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									this.props.getAllScansOrdo();
									this.setState({ openScans: true });
								}}
							>
								<Icon name="print" />
								Documents scannés
							</Label>
							{dualScreen.isAvailable && !this.state.dashboardOpened && (
								<Label
									as="a"
									color="olive"
									size="small"
									onClick={(e) => {
										if (e !== undefined) e.preventDefault();
										this.dashboardToDualScreen();
									}}
								>
									<Icon name="dashboard" />
									{this.state.loadingDashboard && <Loader active size="tiny" inline />}
									Tableau de bord
								</Label>
							)}
							{dualScreen.isAvailable && this.state.dashboardOpened && !this.state.loadingDashboard && this.timerDashboardId > 0 && (
								<Label
									as="a"
									color="red"
									size="small"
									onClick={(e) => {
										if (e !== undefined) e.preventDefault();
										this.closeDashboard();
									}}
								>
									<Icon name="dashboard" />
									Fermer le tableau de bord
								</Label>
							)}
						</Grid.Column>
					</Grid.Row>
					<Grid.Row>
						<Card.Group centered>
							<Card style={{ width: "277px" }}>
								<Card.Content>
									<Card.Header>
										File d'attente
										<span style={{ float: "right" }}>
											{folderHelps.filter((f) => f.status === "NEW" || f.status === "PENDING").length}
											<Popup
												content="En attente d'une secrétaire sénior"
												basic
												trigger={<span>({folderHelps.filter((f) => f.status === "PENDING").length})</span>}
											/>
										</span>
									</Card.Header>
								</Card.Content>
								<Card.Content>
									{stats.init && stats.init.min2 > 0 && (
										<Feed>
											<Feed.Event>
												<Feed.Label
													content={stats.init && stats.init.min2}
													style={{ border: "4px solid black", borderRadius: "20px", textAlign: "center", fontSize: "30px", padding: "12px" }}
												/>
												<Feed.Content>
													<Feed.Summary>dossiers en attente de document.</Feed.Summary>
												</Feed.Content>
											</Feed.Event>
										</Feed>
									)}
									<Feed>
										<Feed.Event>
											<Feed.Label
												content={waitingInfo.min2}
												style={{ border: "4px solid green", borderRadius: "20px", textAlign: "center", fontSize: "30px", padding: "12px" }}
											/>
											<Feed.Content>
												<Feed.Summary>dossiers en attente depuis moins de 2 min.</Feed.Summary>
											</Feed.Content>
										</Feed.Event>
									</Feed>
									<Feed>
										<Feed.Event>
											<Feed.Label
												content={waitingInfo.between210}
												style={{ border: "4px solid orange", borderRadius: "20px", textAlign: "center", fontSize: "30px", padding: "12px" }}
											/>
											<Feed.Content>
												<Feed.Summary>dossiers en attente entre 2 et 10 min.</Feed.Summary>
											</Feed.Content>
										</Feed.Event>
									</Feed>
									<Feed>
										<Feed.Event>
											<Feed.Label
												content={waitingInfo.more10}
												style={{ border: "4px solid red", borderRadius: "20px", textAlign: "center", fontSize: "30px", padding: "12px" }}
											/>
											<Feed.Content>
												<Feed.Summary>dossiers en attente depuis plus de 10 min.</Feed.Summary>
											</Feed.Content>
										</Feed.Event>
									</Feed>
								</Card.Content>
							</Card>
							<Card style={{ width: "277px" }}>
								<Card.Content>
									<Card.Header>
										En traitement{" "}
										<span style={{ float: "right" }}>{folderHelps.filter((f) => f.status === "ASSIGNED" || f.status === "SUPPORT").length}</span>
									</Card.Header>
								</Card.Content>
								<Card.Content>
									<Feed>
										<Feed.Event>
											<Feed.Label
												content={supportInfo.min2}
												style={{ border: "4px solid green", borderRadius: "20px", textAlign: "center", fontSize: "30px", padding: "12px" }}
											/>
											<Feed.Content>
												<Feed.Summary>dossiers en traitement depuis moins de 2 min.</Feed.Summary>
											</Feed.Content>
										</Feed.Event>
									</Feed>
									<Feed>
										<Feed.Event>
											<Feed.Label
												content={supportInfo.between210}
												style={{ border: "4px solid orange", borderRadius: "20px", textAlign: "center", fontSize: "30px", padding: "12px" }}
											/>
											<Feed.Content>
												<Feed.Summary>dossiers en traitement entre 2 et 10 min.</Feed.Summary>
											</Feed.Content>
										</Feed.Event>
									</Feed>
									<Feed>
										<Feed.Event>
											<Feed.Label
												content={supportInfo.more10}
												style={{ border: "4px solid red", borderRadius: "20px", textAlign: "center", fontSize: "30px", padding: "12px" }}
											/>
											<Feed.Content>
												<Feed.Summary>dossiers en traitement depuis plus de 10 min.</Feed.Summary>
											</Feed.Content>
										</Feed.Event>
									</Feed>
								</Card.Content>
							</Card>
						</Card.Group>
					</Grid.Row>
					<Grid.Row style={styles.roundHeaderContainer}>
						<Grid.Column computer={12} tablet={12} mobile={12} style={{ color: "white" }}>
							Liste des secrétaires connectées
						</Grid.Column>
						<Grid.Column
							computer={4}
							tablet={4}
							mobile={4}
							style={{
								color: "white",
								display: "flex",
								justifyContent: "flex-end",
							}}
						>
							Total: {totalConnectedSecretaries}
						</Grid.Column>
					</Grid.Row>
					<Grid.Row>
						{isLoading && <Loader active />}
						{!isLoading && totalConnectedSecretaries > 0 ? (
							<Grid
								style={{
									display: "flex",
									flex: 1,
								}}
							>
								{connectedSecretaries.map((u) => (
									<ConnectedUser key={`userConnected-${u.id}`} user={u} />
								))}
							</Grid>
						) : (
							"Aucune secrétaire active actuellement"
						)}
					</Grid.Row>

					{/* <Grid.Row style={{ paddingTop: 0 }}>
						<SearchInput
							onChange={(e) => this.changeFolderSearchInput(e.target.value)}
							current={currentFolderFilterSearch}
							resetInput={async () => {
								await this.setState({ currentFolderFilterSearch: '' });
								this.loadList(1);
							}}
							placeholder={'Rechercher un dossier'}
						/>
					</Grid.Row> */}
					<Grid.Row style={styles.roundHeaderContainer}>
						<Grid.Column computer={8} tablet={8} mobile={8} style={{ color: "white" }}>
							Liste des demandes d'aides
						</Grid.Column>
						<Grid.Column
							computer={8}
							tablet={8}
							mobile={8}
							style={{
								color: "white",
								display: "flex",
								justifyContent: "flex-end",
							}}
						>
							<div style={{ fontSize: "0.8em", color: "#fff" }}>Pré-inscriptions</div>
							<Checkbox
								style={{ padding: "4px", marginRight: "10px" }}
								slider
								checked={preregister}
								onChange={(e) => {
									this.props.getAllFolderHelp(this.state.page, this.state.done, !this.state.preregister, this.state.nbItems, true);
									this.setState((prevState) => ({ ...prevState, preregister: !prevState.preregister }));
								}}
							/>
							<div style={{ fontSize: "0.8em", color: "#fff", marginLeft: "10px" }}>Dossiers terminés</div>
							<Checkbox
								style={{ padding: "4px", marginRight: "10px" }}
								slider
								checked={done}
								onChange={(e) => {
									this.props.getAllFolderHelp(this.state.page, !this.state.done, this.state.preregister, this.state.nbItems, true);
									this.setState((prevState) => ({ ...prevState, done: !prevState.done }));
								}}
							/>
							{pagination.numberOfPages > 1 && (
								<span style={{ fontSize: "0.9em", marginLeft: "10px", marginRight: "10px" }}>
									(Page: {pagination.page}/{pagination.numberOfPages})
								</span>
							)}
							Total: {totalFolderHelps}
						</Grid.Column>
					</Grid.Row>
					<Grid.Row>
						{isLoading && <Loader active />}
						{!isLoading && totalFolderHelps > 0 ? (
							<Grid
								style={{
									display: "flex",
									flex: 1,
								}}
							>
								{folderHelps
									.slice()
									.sort((a, b) => moment(b.created_at).diff(moment(a.created_at)))
									.map((f, index) => (
										<HelpFolderListItem
											key={`folderhelp-item--${f.id}`}
											total={totalWaitingFolders}
											item={index + 1}
											folderHelp={f}
											goToFolderManager={this.goToFolderManager}
											openHistoricFolderHelpModal={this.openHistoricFolderHelpModal}
											displayDone={done}
											canSee={this.props.user.role !== "NURSE"}
											postAssignToMe={this.props.postAssignToMe}
											support={this.props.acceptSupportFolderHelp}
										/>
									))}
								{pagination.numberOfPages > 1 && (
									<Grid.Row>
										<CustomPagination
											activePage={pagination.page}
											totalPages={pagination.numberOfPages}
											onPageChange={(e, { activePage }) => {
												this.props.getAllFolderHelp(activePage, this.state.done, this.state.preregister, this.state.nbItems, true);
												this.setState({ page: activePage });
											}}
										/>
									</Grid.Row>
								)}
								<HistoricNurseHelpModal
									folderHelp={historicFolderHelp}
									open={openHistoricModal}
									closeHistoricFolderHelpModal={this.closeHistoricFolderHelpModal}
								/>
							</Grid>
						) : (
							"Aucun dossier"
						)}
					</Grid.Row>
				</Grid>
				<ScansFolderHelpModal
					open={this.state.openScans}
					close={() => this.setState({ openScans: false })}
					scans={this.props.scanOrdos}
					getAllScansOrdo={this.props.getAllScansOrdo}
					removeScanOrdo={this.props.removeScanOrdo}
				/>
				<StatsFolderHelpModal
					open={this.state.openStats}
					close={() => this.setState({ openStats: false })}
					folderHelps={folderHelps}
					stats={stats}
					getStats={(start, end) => this.props.getStatsDashboard(start, end)}
					getSecSupport={(id, date, end) => this.getSecSupport(id, date, end)}
					closeSecSupport={() => this.closeSupportedFoldersForSec()}
					supportedFolders={this.state.supportedFolders}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		connectedSecretaries: state.folderHelp.connectedSecretariesList,
		user: state.user,
		folderHelps: state.folderHelp.list,
		scanOrdos: state.folderHelp.scanOrdos,
		pagination: state.folderHelp.pagination,
		stats: state.folderHelp.stats,
		dualScreen: state.dualScreen,
		cancelReasons: state.folderHelp.cancelReasons,
	};
};

const mapDispatchToProps = {
	getSecretariesActive,
	getConnectedUsers,
	getAllFolderHelp,
	setFocusedFolders,
	manageWaitingList,
	sendDashboardToDualScreen,
	stopDashboardToDualScreen,
	closeDashboardToDualScreen,
	getStatsDashboard,
	postAssignToMe,
	acceptSupportFolderHelp,
	getAllScansOrdo,
	removeScanOrdo,
	getSecSupportedFolders,
};

export default connect(mapStateToProps, mapDispatchToProps)(HelpNurses);
